import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Typography,
    FormControl,
    Pagination,
    IconButton,
    Tooltip,
    Modal,
    Box,
    Button,
    Card,
    CardHeader,
    CardContent,
    Divider,
    TextField
} from "@mui/material";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Chip from '@mui/material/Chip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import EditIcon from "@mui/icons-material/Edit";
import BulkOrderCreateDrawer from '../../pages/General/BulkOrderCreateDrawer'
import { getBulkLabels,resetBulkLabel } from '../../pages/BulkOrder/bulkPrintSlice';
import {
    DataGrid,
    GridToolbarContainer,
    GridFooterContainer
} from '@mui/x-data-grid';
// import {
//     DataGridPro,
//     GridToolbarContainer,
//     GridFooterContainer,
//     useGridApiRef,
//     GridAutosizeOptions
// } from '@mui/x-data-grid-pro';
import { fetchBulkOrderReference, fetchBulkOrderDetail,bulkReferenceCooUpdateData, resetBulkOrderNotifications } from '../../pages/BulkOrder/bulkOrderSlice';
import { fetchCountry, fetchState,fetchMultiStates } from '../../pages/General/countryStateCitySlice';
import {
    printBulkLabels
} from '../../pages/Orders/ordersSlice';
//Custom Components Import Starts
import NorowsData from '../General/NorowsData'
import BulkOrderDrawer from '../General/BulkOrderDrawer'
import Notification from '../General/Notification'
import Filters from './Filters'
import Search from './Search'
import Printer from '../../pages/General/Printer'
//Custom Components Import Ends

const BulkOrderPage = () => {

    const dispatch = useDispatch();
    const orders = useSelector(state => state.orders);
    const getprofile = useSelector(state => state.profile.profile);
    const bulkorder = useSelector(state => state.bulkorder && state.bulkorder.bulkorderdata);
    const cooUpdate = useSelector(state => state.bulkorder && state.bulkorder.cooReferenceUpdate);
    const profile = useSelector(state => state.auth);
    const country_code = useSelector(state => state.countrystate.country);
    const filteredCountryData = country_code.data.filter(({ code }) => code );
    const [meta, setMeta] = useState(bulkorder.meta);
    const [bulkOrderDrawerVisible, setBulkOrderDrawerVisible] = useState(false);
    const [bulkOrderCreateDrawerVisible, setBulkOrderCreateDrawerVisible] = useState(false);
    const [referenceId, setReferenceId] = useState("");
    const [showFilter, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [cooModalVisible, setCooModalVisible] = useState(false);
    const [bulkReferenceId, setBulkReferenceId] = useState("");
    const [checkedIds, setCheckedIds] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    
    const initialValues = {
        "coo": "",
        "update":"All"
    }
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});

    const validator = (fieldValues = values) => {
        let temp = { ...errors }
        if ('coo' in fieldValues)
            temp.coo = fieldValues.coo ? "" : "This field is required."

        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x == "")
    }

    const [bulkdrawershow, setbulkdrawershow] = useState(false);

    const bulkOrderCreateCallback = (item) => {
        setBulkOrderCreateDrawerVisible(true)
    }
    const bulkOrderCreateOnClose = (values) => {
        setBulkOrderCreateDrawerVisible(false);
    };
    const bulkOrderCallback = (item) => {
        setReferenceId(item)
        dispatch(fetchBulkOrderDetail(item));
        setBulkOrderDrawerVisible(true)
        setbulkdrawershow(true)
        let userid=profile && profile.profile && profile.profile.id
        let referenceid=item
        dispatch(getBulkLabels(referenceid))
    }
    const bulkOrderOnClose = (values) => {
        setBulkOrderDrawerVisible(false);
    };

    const cooEditAction = (_id) => {
        setCooModalVisible(true)
        setBulkReferenceId(_id)
    }
    const onExportClick = (_id) => {
        let url = process.env.REACT_APP_API_DOMAIN +`/labelgen/bulk-shipments/successful-shipments-export?reference_id=${_id}`;
        window.open(url,"_blank")
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };
    const tagstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper'
    };

    const onSelectionChange = (currentSelectedIds, currentAllItems) => {
        let tempCheckedIds = [...checkedIds]
        let tempCheckedItems = [...checkedItems];
        currentAllItems.map((item) => (
            checkBoxCompute(tempCheckedIds, tempCheckedItems, item, currentSelectedIds)
        ))
        setCheckedIds(tempCheckedIds)
        setCheckedItems(tempCheckedItems)
    }

    const checkBoxCompute = (tempCheckedIds, tempCheckedItems, item, currentSelectedIds) => {
        const index = tempCheckedIds.indexOf(item._id);
        const method = (currentSelectedIds.indexOf(item._id) > -1)
        if (method) {
            if (index === -1) {
                tempCheckedIds.push(item._id);
                tempCheckedItems.push(item)
            }
        } else if (!method) {
            if (index > -1) {
                tempCheckedIds.splice(index, 1);
                tempCheckedItems.splice(index, 1);
            }
        }
        return [tempCheckedIds, tempCheckedItems];
    }

     const printLabelBulk = () => {
        let urls = []
        checkedItems.forEach((item) => {
            let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
            if (item && item.bulk_label_url) {
                urls.push(item.bulk_label_url)
            }
        })
        if (urls.length !== 0) {
            dispatch(printBulkLabels(urls, getprofile.id))
        } 
    }

    useEffect(() => {
            if (orders.bulkLabel && orders.bulkLabel.filename && orders.bulkLabel.filename !== "" && orders.bulkLabel.is_shown === false) {
                setPrintUrl(process.env.REACT_APP_LABELINGCHIMP_LABEL_API_DOMAIN + "/merge-pdf?filename=" + orders.bulkLabel.filename)
                setIsPrinted(false)
                setCheckedIds([])
                setCheckedItems([])
            }
    }, [orders.bulkLabel])
    
    const columns = [

        {
            field: '_id',
            headerName: 'Reference',
            sortable: false,
            minWidth:'250',
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return <span style={{ color: 'rgb(24, 144, 255)', cursor: 'pointer' }} onClick={e => { bulkOrderCallback(params.row._id) }}>{params.row._id}</span>

            }
        },
        {
            field: 'upload_type',
            headerName: 'Type',
            sortable: false,
            minWidth:'200',
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                if(params.row.upload_type && params.row.upload_type==='ORDER'){
                    return <Chip label={"ONLY ORDER"} color="primary"  style={{ backgroundColor:'#884EA0',width:'165px',height:'28px',fontSize:'12px' }}/>
                }else{
                    return <Chip label={"ORDER + SHIPMENT"} color="success"  style={{backgroundColor:'#154360',width:'165px',height:'28px',fontSize:'12px' }}/>
                }
            }
        },
        {
            field: 'total_shipments',
            headerName: <Typography style={{fontWeight:'600',fontSize:'14px'}}>Total<br /> shipments</Typography>,
            sortable: false,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'success_count',
            headerName: <Typography style={{fontWeight:'600',fontSize:'14px'}}>Success<br /> Count</Typography>,
            sortable: false,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'failure_count',
            headerName: <Typography style={{fontWeight:'600',fontSize:'14px'}}>Failure<br /> Count</Typography>,
            sortable: false,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'status',
            headerName: 'Status',
            sortable: false,
            minWidth:'200',
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                if(params.row.status=='PENDING'){
                    return <Chip label={params.row.status} color="primary"  style={{ width:'120px',height:'28px',fontSize:'12px' }}/>
                }else if(params.row.status=='COMPLETED'){
                    return <Chip label={params.row.status} color="success"  style={{ width:'120px',height:'28px',fontSize:'12px' }}/>
                }else{
                    return "-"
                }
            }
        },
        {
            field: 'notes',
            headerName: 'Notes',
            sortable: false,
            minWidth:'200',
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            minWidth:'200',
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return <div>
                    <span style={{ marginRight: '5px' }}><Tooltip title="Edit Country of Origin" placement="left-start">
                        <IconButton onClick={() => cooEditAction(params.row._id)}>
                            <EditIcon style={{ color: "#1890ff", cursor: 'pointer' }}  />
                        </IconButton>
                    </Tooltip>
                    </span>
                    <span style={{ marginRight: '5px' }}><Tooltip title="download successful shipments" placement="left-start">
                        <IconButton 
                            disabled={params.row.status=='COMPLETED' ? false :true}
                            style={{
                                color: params.row.status=='COMPLETED' ?  '#1890ff' : 'rgba(0,0,0,.54)' ,
                                cursor: params.row.status=='COMPLETED' ?  'pointer' : 'not-allowed' ,
                                pointerEvents: params.row.status=='COMPLETED' ?'auto' : 'none'  
                            }}
                            onClick={() => onExportClick(params.row._id)}>
                            <FileDownloadIcon  />
                        </IconButton>
                    </Tooltip>
                    </span>
                </div>
            }
        },
        {
            field: 'created_at',
            headerName: 'Uploaded Date',
            headerClassName: 'super-app-theme--header',
            minWidth:'200'        
        }

    ];

     // Function to disable selection on specific rows
        const isRowSelectable = (params) => {
            // Disable row selection where the status is 'inactive'
            return typeof params.row.bulk_label_url !== 'undefined';
        };

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onChangePerPage = (event) => {
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
        setCheckedIds([])
        setCheckedItems([])
    }

    const onChangePagination = (event, page) => {
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
        setCheckedIds([])
        setCheckedItems([])
    }

    function CustomTotalRows() {

        return (
            <div className="custom-total-rows">
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    Showing {bulkorder && bulkorder.data && bulkorder.data.length} of {(bulkorder && bulkorder.meta && bulkorder.meta.total) ? bulkorder.meta.total : 0}
                </FormControl>
            </div>
        )
    }


    function CustomPagesizeoptions() {

        return (
            <div className="custom-page-size-options">
                <span>
                    Show <select
                        value={meta && meta.per_page}
                        onChange={onChangePerPage}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select> entries
                </span>
            </div>
        )
    }

    function CustomToolbar() {

        return (
            <GridToolbarContainer>
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }

    function CustomPagination() {

        return (
            <GridFooterContainer style={{justifyContent:'end'}}>
                <Pagination
                    color="primary"
                    shape="circular"
                    page={bulkorder && bulkorder.meta && bulkorder.meta.current_page}
                    count={bulkorder && bulkorder.meta && bulkorder.meta.last_page}
                    onChange={onChangePagination}
                />
            </GridFooterContainer>
        );
    }


    useEffect(() => {
        dispatch(fetchBulkOrderReference(meta))
        dispatch(fetchCountry());
        setValues(initialValues)
        setErrors({})
    }, [meta]);

    const onMenuClick = (type, show) => {
        setShowSearch((type === "search" && show === true) ? true : false)
        setShowFilter((type === "filter" && show === true) ? true : false)
    }
    const onChangeCountry = id => {
        setValues({
            ...values,
            ['coo']: id
        })
        setErrors({ "coo": "" })
    }
    const onChangeCooUpdate = (e) => {
        setValues({
            ...values,
            ['update']: e.target.value
        })
    }
    const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
          if (key.code == country_code) {
            filteredValue = key;
          }
        });
         return filteredValue;
      };

      const handleSubmit = e => {
        e.preventDefault()
        const isValid = validator(values)
        if (isValid) {
            let bulkid={}
            bulkid["_id"] = bulkReferenceId;
            Object.assign(values, bulkid);
            dispatch(bulkReferenceCooUpdateData(getprofile.id,values))
            setCooModalVisible(false)
            setValues(initialValues)
            setErrors({})
            setBulkReferenceId('')
        }
    }
    return (
        <>
            {(bulkorder  && bulkorder.notification && bulkorder.notification.show) &&
                    <Notification
                        is_open={bulkorder.notification.show}
                        messageType={bulkorder.notification.messageType}
                        messages={bulkorder.notification.messageContent}
                        handleClose={() => dispatch(resetBulkOrderNotifications())}
                    />}
             {(cooUpdate  && cooUpdate.notification && cooUpdate.notification.show) &&
                    <Notification
                        is_open={cooUpdate.notification.show}
                        messageType={cooUpdate.notification.messageType}
                        messages={cooUpdate.notification.messageContent}
                        handleClose={() => dispatch(resetBulkOrderNotifications())}
             />}
            
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />


            <Modal
                open={cooModalVisible}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={tagstyle}>
                    <Card sx={{ minWidth: 600 }} className="sc--cardhead--details">
                        <CardHeader title='Country of Origin' />
                        <Divider />
                        <CardContent>
                            <div className="sc--form--center" style={{ margin: '10px 0' }}>
                                <TextField id="standard-basic"
                                        label="ReferenceId"
                                        variant="standard"
                                        name="referenceId"
                                        type="text"
                                        slotProps={{
                                            input: {
                                              readOnly: true,
                                            },
                                          }}
                                        value={bulkReferenceId}
                                        style={{ width: '100%' }}
                                    />
                            </div>
                            <div className="sc--form--center" style={{ margin: '10px 0' }}>
                            <Autocomplete
                                    className="help-text-error"
                                    disablePortal
                                    name="coo"
                                    id="country-select-demo"
                                    sx={{ width: "100%", margin: '8px'}}
                                    options={filteredCountryData}
                                    autoHighlight
                                    loading={country_code && country_code.loading}
                                    getOptionLabel={(option) => option.name}
                                    value={getSelectedCountry(values && values.coo)}
                                    renderOption={(props, option) => (
                                    <MenuItem {...props} value={option.code} key={option.code}>
                                        {option.icon} {option.name}
                                    </MenuItem>
                                    )}
                                    onChange={(event, value) => {
                                    if (value !== null) {
                                        onChangeCountry(value.code);
                                    } else {
                                        onChangeCountry("");
                                    }
                                    }}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Country of Origin"
                                        variant="standard"
                                        helperText={errors.coo}
                                    />
                                    )}
                                /> 
                            </div>
                            <div className="sc--form--center"   style={{ margin: '10px 10px',justifyContent:'left' }}>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="update"
                                    value={values.update}
                                    onChange={onChangeCooUpdate}
                                >
                                    <FormControlLabel value="All"  control={<Radio size="small" />} label={<Typography style={{ fontSize: '12px' }}>Update ALL lineitems</Typography>} />
                                    <FormControlLabel value="Not Exist" control={<Radio size="small" />} label={<Typography style={{ fontSize: '12px' }}>Update only the lineitems that don't have a Country of Origin</Typography>} />
                                </RadioGroup>
                            </div>
                            <div className="sc--form--center" style={{ margin: '30px 0' }}>
                                <Button variant="outlined" style={{marginRight:'10px'}}  onClick={handleSubmit}>Submit</Button>
                                <Button variant="outlined" onClick={() => { 
                                        setCooModalVisible(false)
                                        setValues(initialValues)
                                        setErrors({})
                                        setBulkReferenceId('')
                                        }}>Cancel</Button>
                            </div>
                        </CardContent>
                    </Card>
                </Box>
            </Modal >
            <div className="scmaincard">
                <div className="sccardhead">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="h5" gutterBottom component="div">
                            Bulk Order
                    </Typography>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ul className="features-list">
                            {(checkedIds && checkedIds.length >= 1) &&
                                <li>
                                    <Tooltip title="Bulk Print" placement="top-start">
                                        <IconButton onClick={() => printLabelBulk()}>
                                            <LocalPrintshopIcon style={{ color: 'rgb(25, 118, 210)' }} />
                                        </IconButton>
                                    </Tooltip>
                                </li>
                            }
                            <li>
                                <Tooltip title="Bulk orders upload" placement="top-start">
                                    <IconButton onClick={bulkOrderCreateCallback}>
                                        <UploadFileOutlinedIcon style={{ color: 'rgb(25, 118, 210)' }} />
                                    </IconButton>
                                </Tooltip>
                            </li>
                            <li>
                                <Tooltip title="Seacrh" placement="top-start">
                                    <IconButton style={(showSearch) ? { backgroundColor: 'rgb(230, 230, 230)' } : {}} onClick={() => onMenuClick("search", !showSearch)}>
                                        <SearchIcon style={{ color: 'rgb(25, 118, 210)' }} />
                                    </IconButton>
                                </Tooltip>
                            </li>
                            {/* <li>
                                <Tooltip title="Filter" placement="top-start">
                                    <IconButton onClick={() => onMenuClick("filter", !showFilter)}>
                                        <FilterAltOutlinedIcon style={{ color: 'rgb(25, 118, 210)' }} />
                                    </IconButton>
                                </Tooltip>
                            </li> */}
                        </ul>
                    </div>
                </div>
                <Search visible={showSearch} meta={meta} setMeta={setMeta} />
                <Filters visible={showFilter} meta={meta} setMeta={setMeta} />
                <div style={{ width: '100%', background: '#fff', marginTop: "20px" }}>
                    <DataGrid
                        style={{ paddingTop: "37px"}}
                        getRowId={(row) => row._id}
                        rows={bulkorder && bulkorder.data}
                        columns={columns}
                        autoHeight={true}
                        disableColumnFilter={true}
                        disableColumnMenu={true}
                        sortingMode="server"
                        checkboxSelection
                        onRowSelectionModelChange={(newSelectionModel) => { onSelectionChange(newSelectionModel, bulkorder && bulkorder.data) }}
                        rowSelectionModel={checkedIds}
                        onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                        sortModel={meta && meta.sorting && JSON.parse(meta.sorting)}
                        disableRowSelectionOnClick
                        isRowSelectable={isRowSelectable}  // Disable checkbox for rows with inactive status
                        slots={{
                            loadingOverlay: LinearProgress,
                            footer: CustomPagination,
                            toolbar: CustomToolbar,
                            NorowsData
                        }}
                        loading={
                            (bulkorder && bulkorder.loading) || (cooUpdate && cooUpdate.loading) ||
                            (orders && orders.bulkLabel && orders.bulkLabel.loading) 
                        }
                    />

                </div>

            </div>
            {bulkdrawershow &&
            <BulkOrderDrawer visible={bulkOrderDrawerVisible} referenceId={referenceId} bulkDraweronClose={bulkOrderOnClose} checkReload={bulkOrderCallback}
            />
            }
            <BulkOrderCreateDrawer
                visible={bulkOrderCreateDrawerVisible} onClose={bulkOrderCreateOnClose}
            />
        </>
    );
}

export default BulkOrderPage;
